import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.modelAdding;

const modelAddingData = createSelector([selector], (state) => state);

export default {
  modelAddingData
};
